export default __webpack_public_path__ + "static/media/slider.aca8f0a7.svg";